<div class="main-section">

  <section *ngIf="this.gameConfig.sliderName === 'slider'">
    <div id="carouselExampleIndicators" class="carousel slide  hero-banner" data-bs-ride="carousel">
      <div class="carousel-indicators">
        <button type="button" *ngFor="let item of gameConfig.imageList; let i = index;" data-bs-target="#carouselExampleIndicators" attr.data-bs-slide-to="{{i}}" class="{{ (i == 0) ? 'active' : '' }}"
          attr.aria-label="Slide {{i}}"></button>

      </div>
      <div class="carousel-inner container">
        <ng-container *ngFor="let item of gameConfig.imageList; let i = index;">
        <div class="carousel-item" [ngClass]="{'active': i == 0}">
          <div class="row">
            <div class="col-lg-6  ps-lg-5 ps-0 order-1 order-lg-0">
              <div class="carousel-text">
                <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
                <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
                <p>{{this.gameConfig.description}}</p>
              </div>
            </div>
            <div class="col-lg-6 text-center order-0 order-lg-1 mt-3 carousel-img">
              <img [src]="item" alt="carousel-1" class=" game-carousel" />
            </div>
          </div>
        </div>
      </ng-container>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
        data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
        data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </section>

  <section *ngIf="this.gameConfig.sliderName === 'noslider'">
    <div class="">
        <div class="container ">
            <div class="px-60">
                <div class="row">
                    <div class="col-md-6  ps-lg-5 ps-0 order-1 order-md-0">
                        <div class="carousel-text video-text">
                            <!-- <h4>{{portalName}}</h4> -->
                            <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
                <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
                            <p>{{this.gameConfig.description}}</p>
                        </div>
                    </div>
                    <div class="col-md-6 text-center order-0 order-md-1 mt-3 carousel-img">
                        <div class="image-warp d-flex" *ngFor="let item of gameConfig.imageList; let i = index;">
                            <img [src]="item" class="img-fluid" alt="image" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>


  <section class="design-responsive-1" *ngIf="this.gameConfig.sliderName === 'videoSlider'">
    <div class=" hero-banner">
        <div class="container ">
            <div class="px-60">
                <div class="row">
                    <div class="col-md-6  ps-lg-5 ps-0 order-1 order-md-0">
                        <div class="carousel-text video-text">
                          <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
                          <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
                          <p>{{this.gameConfig.description}}</p>                          <a href="#" class="btn btn-ghost btn-post mt-0">View</a>
                        </div>
                    </div>
                    <div class="col-md-6 text-center order-0 order-md-1 mt-3 carousel-img">
                        <div class="image-warp d-flex">
                            <div class="swiper mySwiper">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" *ngFor="let item of gameConfig.imageList; let i = index;" >
                                        <div class="image-slider img-1">
                                            <img [src]="item" alt="" class="img-fluid">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>


    <section class="mt-64 design-responsive">
        <div class="design-11">
            <img src="./../../assets/images/2.png" alt="">
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center">
                        <h2>{{this.gameConfig.faq}}</h2>
                    </div>

                </div>
                <div class="col-lg-6 mx-auto mt-3">
                    <!-- <div class="row">
                        <div class="col-6 mb-2">
                            <div class="text-start faq">
                                <h6>MSISDN :</h6>
                            </div>
                        </div>

                        <div class="col-6 mb-2">
                            <div class="text-start faq">
                                <h6 *ngIf="queryParam.id !== '414'">SUBSCRIPTION PACK: </h6>
                                <h6 *ngIf="queryParam.id == '414'">FORFAIT D'ABONNEMENT :
                                </h6>
                            </div>
                        </div>

                    </div> -->

                    <div class="accordion accordion-flush" id="accordionFlushExample">
                        <div class="accordion-item mb-3" *ngFor="let item of faq; let i = index;">
                            <h2 class="accordion-header" id="flush-headingOne">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseOne" aria-expanded="false"
                                    aria-controls="flush-collapseOne">
                                    {{item.question}}
                                </button>
                            </h2>
                            <div id="flush-collapseOne" class="accordion-collapse collapse"
                                aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body">
                                  {{item.answer}}
                                </div>
                            </div>
                        </div>
                        <!-- <div class="accordion-item mb-3">
                            <h2 class="accordion-header" id="flush-headingTwo">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseTwo" aria-expanded="false"
                                    aria-controls="flush-collapseTwo">
                                    What are the charges?
                                </button>
                            </h2>
                            <div id="flush-collapseTwo" class="accordion-collapse collapse"
                                aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body">Current subscription pack charges will be apply according to
                                    the package.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item mb-3">
                            <h2 class="accordion-header" id="flush-headingThree">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseThree" aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    How I can pay for the service
                                </button>
                            </h2>
                            <div id="flush-collapseThree" class="accordion-collapse collapse"
                                aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body">
                                    You will be charged from you existing balance (prepaid) or monthly bill (Postpaid).
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item mb-3">
                            <h2 class="accordion-header" id="flush-headingThree">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapsefour" aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    Is this compatible for all phones.
                                </button>
                            </h2>
                            <div id="flush-collapsefour" class="accordion-collapse collapse"
                                aria-labelledby="flush-headingfour" data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body"> Compatible to IOS, Android, Windows, Symbian phones.</div>
                            </div>
                        </div>

                        <div class="accordion-item mb-3">
                            <h2 class="accordion-header" id="flush-headingThree">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapsefive" aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    How many content pieces I can access?
                                </button>
                            </h2>
                            <div id="flush-collapsefive" class="accordion-collapse collapse"
                                aria-labelledby="flush-headingfive" data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body"> User can access all content subscribed to the service.
                                </div>
                            </div>
                        </div>

                        <div class="accordion-item mb-3">
                            <h2 class="accordion-header" id="flush-headingThree">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapsesix" aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    How long I can use this service
                                </button>
                            </h2>
                            <div id="flush-collapsesix" class="accordion-collapse collapse"
                                aria-labelledby="flush-headingsix" data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body">You can use the service as long as you are subscribed to it.
                                    The service will be auto-renewed on expiry. If you wish to unsubscribe, you would
                                    need to deactivate the service.
                                </div>
                            </div>
                        </div>

                        <div class="accordion-item mb-3">
                            <h2 class="accordion-header" id="flush-headingThree">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseseven" aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    What is the age criterion to avail this service?
                                </button>
                            </h2>
                            <div id="flush-collapseseven" class="accordion-collapse collapse"
                                aria-labelledby="flush-headingseven" data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body">The service caters to all age group.</div>
                            </div>
                        </div> -->



                    </div>
                </div>

            </div>
        </div>
    </section>


</div>
